<template>
    <div>
    <v-card style="min-height: 200px">
        <v-text-field v-model="token" ></v-text-field>
        <v-btn @click="login">Login</v-btn> <v-btn v-show="savedLogin" @click="continueSurfing" >Continue</v-btn>
        <v-card-text v-if="show.wrong">
            Wrong hash.
        </v-card-text>
    </v-card>
        <div class="container" v-html="html">
        </div>
    </div>

</template>

<script>
    export default {
        name: "Login",
        data(){
            return {
                token:'',
                reactive: localStorage.getItem('tokens'),
                html: '',
                show:{
                    wrong: false,
                }
            }
        },
        computed:{
            savedLogin(){
                return this.reactive !== '';
            },
        },
        methods:{
            setToken(tokenValue){
                this.reactive = tokenValue;
                localStorage.setItem('token', tokenValue);
            },
            clearToken(){
                this.reactive = '';
                localStorage.removeItem('token');
            },
            continueSurfing(){
                const formEntries = {
                    token: this.token,
                };
                let formData = new FormData();
                for ( const key in formEntries ) {
                    formData.append(key, formEntries[key]);
                }
                const self = this;
                this.axios.post('clients/login',
                    formEntries
                ).then(res => {
                    if(res.data.success){
                        this.html = res.data.html.data;
                    }
                    else
                        self.clearToken();
                }, error => {
    //                this.$refs.validatePopup.showSubmissionError();
                });
            },
            login(){
                this.show.wrong=true;
                this.setToken(this.token);
                this.continueSurfing();

            }
        }
    }
</script>

<style scoped>

</style>
